import { collection, addDoc, getFirestore, Timestamp } from 'firebase/firestore';
import { firebaseApp } from './firebaseConfig';

const db = getFirestore(firebaseApp);

/**
 * Records interest from an iOS user affected by the current payments outage,
 * so they can be emailed once it's resolved.
 */
export async function addIosPaymentNotifyRequest(
  email: string,
  userId: string | null,
): Promise<boolean> {
  try {
    const ref = collection(db, 'ios-users-payments');
    await addDoc(ref, {
      email,
      userId: userId ?? null,
      createdAt: Timestamp.now(),
    });
    return true;
  } catch (error) {
    console.error('Error adding iOS payment notify request:', error);
    return false;
  }
}
